import { useEffect, useState } from "react";
import { previewSalesSimulation } from "../auth/apiSalesSimulation";

// The generic calculator and Product pricing both use the server profitability
// engine. A superseded response must never replace the current scenario.
export default function useSalesSimulation(inputs, token) {
  const key = JSON.stringify(inputs);
  const [state, setState] = useState({ key: null, result: null, error: false, loading: true });
  useEffect(() => {
    const controller = new AbortController();
    let current = true;
    const timer = setTimeout(async () => {
      try {
        const result = await previewSalesSimulation(JSON.parse(key), controller.signal, token);
        if (current) setState({ key, result, error: false, loading: false });
      } catch (error) {
        if (current) setState({ key, result: null, error: true, loading: false });
      }
    }, 250);
    return () => { current = false; clearTimeout(timer); controller.abort(); };
  }, [key, token]);
  return state.key === key ? state : { result: null, error: false, loading: true };
}
